/**
 * Single source of truth for all aspect ratios used across the app.
 * Each ratio is defined once with its numeric proportions.
 */

export interface RatioDef {
  id: string;
  label: string;
  w: number;
  h: number;
}

export const ALL_RATIOS: RatioDef[] = [
  { id: 'auto', label: 'Авто', w: 1, h: 1 },
  { id: '1:1',  label: '1:1',  w: 1,  h: 1  },
  { id: '3:4',  label: '3:4',  w: 3,  h: 4  },
  { id: '4:3',  label: '4:3',  w: 4,  h: 3  },
  { id: '2:3',  label: '2:3',  w: 2,  h: 3  },
  { id: '3:2',  label: '3:2',  w: 3,  h: 2  },
  { id: '9:16', label: '9:16', w: 9,  h: 16 },
  { id: '16:9', label: '16:9', w: 16, h: 9  },
  { id: '21:9', label: '21:9', w: 21, h: 9  },
];

const ratioMap = new Map(ALL_RATIOS.map(r => [r.id, r]));

export function getRatio(id: string): RatioDef | undefined {
  return ratioMap.get(id);
}

/** Compute pixel dimensions for a ratio preview rectangle */
export function ratioPreviewSize(w: number, h: number, maxPx = 28): { width: number; height: number } {
  const max = Math.max(w, h);
  return {
    width: Math.round((w / max) * maxPx),
    height: Math.round((h / max) * maxPx),
  };
}

// --- Presets for different contexts ---
export const IMAGE_EDIT_RATIOS  = ['auto', '1:1', '9:16', '2:3', '3:4', '4:3', '3:2', '16:9', '21:9'];
export const IMAGE_GEN_RATIOS   = ['1:1', '4:3', '3:2', '16:9', '21:9', '3:4', '2:3', '9:16'];
export const VIDEO_RATIOS       = ['1:1', '4:3', '3:2', '16:9', '21:9', '3:4', '2:3', '9:16'];
export const CLIPS_RATIOS       = ['1:1', '16:9', '9:16'];
